export default [
  'daily',
  'weekly',
  'monthly',
  'every three months',
  'semi annually',
  'annually',
];
